import AdminContainer from '../../Utility/AdminContainer';
import { PencilSimple } from '@phosphor-icons/react';
import useUsers from '../../../Hooks/useUsers';
import useSearchFilter from '../../../Hooks/useSearchFilter';
import AdminBox from '../../Utility/AdminBox';
import AdminViewHeader from '../../Utility/AdminViewHeader';
import AdminViewContent from '../../Utility/AdminViewContent';
import { User } from '../../../Types';
import { PaginationWrapper } from '../../Utility/PaginationWrapper';
import { PaginationListType } from '../../../Types/PaginationParams';
import SearchFilter from '../../Utility/SearchFilter';

function Users() {
    const { i18n, handleNavigate, windowWidth, getBreakpoint, userService } = useUsers();

    const { query, localQuery, searchActions } = useSearchFilter({
        initialQuery: null,
    });

    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(157px,300px),minmax(157px,1fr)]';

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox classString="px-4">
                    <SearchFilter
                        value={localQuery}
                        onChange={searchActions.setLocalQuery}
                        onApply={searchActions.applyQuery}
                        onClear={searchActions.clearQuery}
                    />
                    <div className="hidden md:block">
                        <AdminViewHeader
                            gridCols={GRID_COLS}
                            cols={{
                                cols: [
                                    {
                                        text: i18n.translate({ id: 'adminHeader.mainCol', sourceName: 'Main' }),
                                    },
                                    {
                                        text: i18n.translate({ id: 'users.userName', sourceName: 'Users' }),
                                    },
                                ],
                            }}
                        />

                        <hr className="border-layout-borderColor mt-5" />
                    </div>

                    <PaginationWrapper
                        listType={PaginationListType.Users}
                        itemsFunction={userService.getUsersByPage}
                        itemsPerPage={15}
                        query={query || null}
                        renderItem={(user: User, index: number) => (
                            <AdminViewContent
                                key={user.identifier}
                                mobile={windowWidth < getBreakpoint('md')}
                                identifier={user.identifier}
                                gridCols={GRID_COLS}
                                cols={{
                                    optionalCols: [
                                        {
                                            content: user.givenName + ' ' + user.familyName,
                                        },
                                        {
                                            content: user.userName,
                                        },
                                    ],
                                    button: {
                                        buttons: [
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => handleNavigate(user.identifier),
                                                icon: <PencilSimple />,
                                            },
                                        ],
                                    },
                                }}
                            />
                        )}
                    />
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default Users;
